import React from "react";

import DashboardCard from "../Common/DashboardCard";
import SectionHeader from "../Common/SectionHeader";
import TutorialCard from "./TutorialCard";

// Pass tutorials already run through mapQuizToTutorialCard() for each
// quiz/attempt pair.
export default function TutorialsCard({ tutorials = [], onViewAll, onAction }) {
    return (
        <DashboardCard>
            <SectionHeader
                title="Tutorials & Quizzes"
                actionText="View All"
                onAction={onViewAll}
            />

            {tutorials.length === 0 ? (
                <TutorialsEmptyState />
            ) : (
                tutorials.map((tutorial) => (
                    <TutorialCard
                        key={tutorial.id}
                        {...tutorial}
                        onAction={() => onAction?.(tutorial.id)}
                    />
                ))
            )}
        </DashboardCard>
    );
}

function TutorialsEmptyState() {
    return (
        <p style={{ color: "#94A3B8", fontSize: 14 }}>
            No tutorials assigned yet.
        </p>
    );
}
